//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
/**
 * Created by z003f2zh on 10.09.2015.
 */

(function () {

    'use strict';

    angular
        .module('container.widgets')
        .directive('srsngTabset', srsngTabset);

    function srsngTabset() {

        return {
            restrict: 'E',
            templateUrl: 'container/ui/app/widgets/tabs/tabset.html',
            transclude: true,
            scope: {
                isCollapsed: '=collapsed',
                collapsible: '='
            },
            controller: controller,
            link: link
        };

        function controller($scope) {

            $scope.tabs = [];
            $scope.isCollapsible = $scope.collapsible === undefined || $scope.collapsible;

            this.addTab = function (tab) {

                if ($scope.tabs.length == 0)
                    $scope.setActive(tab);

                $scope.tabs.push(tab);
            };

            $scope.setActive = function (tab) {

                if ($scope.isCollapsible && tab.isActive) {
                    $scope.setCollapsed(!$scope.isCollapsed);
                } else {
                    _.each($scope.tabs, function (tab) {
                        tab.isActive = false;
                    });

                    tab.isActive = true;
                }
            };

            $scope.setCollapsed = function (collapse) {
                $scope.isCollapsed = collapse;
            }
        }

        function link(scope, element, attrs) {
            // this is intentional override
        }

    }
})();

